import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getChoice } from "@/lib/edition";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/google-session", { session_id: sid, edition: getChoice() })
      .then((r) => { setUser(r.data); window.history.replaceState(null, "", "/"); navigate("/", { replace: true }); })
      .catch((e) => { setError(formatApiError(e)); setUser(false); window.history.replaceState(null, "", "/login"); });
  }, [location.hash, navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center px-6 text-center">
      {error ? (
        <div data-testid="google-auth-error">
          <p className="font-display text-3xl text-slate-900">Sign-in not allowed</p>
          <p className="mt-2 text-slate-600">{error}</p>
          <button data-testid="back-to-login" onClick={() => navigate("/login", { replace: true })} className="mt-6 rounded-xl bg-slate-900 text-black px-5 py-2.5 font-semibold">Back to login</button>
        </div>
      ) : <p className="font-mono text-xs uppercase tracking-widest text-slate-500">Signing you in…</p>}
    </div>
  );
}
